import type { SVGProps } from 'react'
const SvgSyCalendarAdd = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M7 4.432c0-.155 0-.233-.05-.278-.052-.045-.128-.035-.28-.015-1.12.143-1.902.436-2.498 1.033C3 6.343 3 8.229 3 12s0 5.657 1.172 6.828S7.229 20 11 20h2c3.771 0 5.657 0 6.828-1.172S21 15.771 21 12s0-5.657-1.172-6.828c-.596-.597-1.378-.89-2.499-1.033-.151-.02-.227-.03-.278.015S17 4.277 17 4.432V6.5a1.5 1.5 0 0 1-3 0V4.3c0-.141 0-.212-.044-.255S13.842 4 13.701 4H10.3c-.142 0-.212 0-.256.045C10 4.088 10 4.159 10 4.3v2.2a1.5 1.5 0 1 1-3 0z"
			clipRule="evenodd"
		/>
		<path d="M8.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5m7 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5" />
		<g strokeLinecap="square">
			<path d="M11.4 9.4v7.2h1.2V9.4z" />
			<path d="M8.4 12.4v1.2h7.2v-1.2H9z" />
		</g>
	</svg>
)
export default SvgSyCalendarAdd
